import React from 'react';
import { ShieldAlert, Users, FileText, AlertTriangle, Flag, ArrowLeft, MessageSquare, Gavel, Paperclip } from 'lucide-react';
import { DashboardLayout } from '../../components/DashboardLayout';
import { Link, useParams } from 'react-router-dom';
export function DisputeDetailPage() {
  const {
    id
  } = useParams();
  const navItems = [{
    label: 'Verification Queue',
    icon: FileText,
    path: '/admin',
    badge: '12'
  }, {
    label: 'User Management',
    icon: Users,
    path: '/admin/users'
  }, {
    label: 'Disputes',
    icon: Flag,
    path: '/admin/disputes'
  }, {
    label: 'Risk Analysis',
    icon: AlertTriangle,
    path: '/admin/risk'
  }];
  return <DashboardLayout title="Admin Console" personaLabel="ADMIN" personaColor="bg-red-100 text-red-800 border-red-200" navItems={navItems} userInitials="AD" data-id="element-1320">
      <div className="mb-6" data-id="element-1321">
        <Link to="/admin/disputes" className="flex items-center gap-2 text-sm text-gray-500 hover:text-[#1f2933] mb-4" data-id="element-1322">
          <ArrowLeft className="w-4 h-4" data-id="element-1323" /> Back to Disputes
        </Link>
        <div className="flex flex-col md:flex-row justify-between items-start gap-4" data-id="element-1324">
          <div data-id="element-1325">
            <h1 className="text-2xl font-bold mb-1" data-id="element-1326">
              Dispute #{id || 'DSP-8821'}
            </h1>
            <p className="text-gray-500 font-mono text-sm" data-id="element-1327">
              Token amount not refunded • High Priority
            </p>
          </div>
          <div className="flex gap-3" data-id="element-1328">
            <button className="px-4 py-2 border border-gray-300 bg-white text-sm font-bold hover:bg-gray-50" data-id="element-1329">
              Escalate to Legal
            </button>
            <button className="px-4 py-2 bg-[#1f2933] text-white text-sm font-bold hover:bg-gray-800 flex items-center gap-2" data-id="element-1330">
              <Gavel className="w-4 h-4" data-id="element-1331" /> Resolve & Close
            </button>
          </div>
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-8" data-id="element-1332">
        <div className="lg:col-span-2 space-y-8" data-id="element-1333">
          {/* Discussion Thread */}
          <div className="bg-white border border-gray-300 p-6" data-id="element-1334">
            <h2 className="font-bold text-lg mb-6 flex items-center gap-2" data-id="element-1335">
              <MessageSquare className="w-5 h-5" data-id="element-1336" /> Evidence & Discussion
            </h2>

            <div className="space-y-6 mb-6" data-id="element-1337">
              <div className="bg-blue-50 p-4 border border-blue-100 rounded-sm" data-id="element-1338">
                <div className="flex justify-between mb-2" data-id="element-1339">
                  <span className="font-bold text-sm text-blue-900" data-id="element-1340">
                    Buyer (Complainant)
                  </span>
                  <span className="text-xs text-blue-700" data-id="element-1341">2 days ago</span>
                </div>
                <p className="text-sm text-gray-800" data-id="element-1342">
                  I paid a token of ₹50,000 for Plot A-101. The seller cancelled
                  the deal but hasn't refunded the amount yet.
                </p>
                <div className="mt-3 flex gap-2" data-id="element-1343">
                  <span className="flex items-center gap-1 text-xs font-mono bg-white px-2 py-1 border border-blue-200 rounded" data-id="element-1344">
                    <Paperclip className="w-3 h-3" data-id="element-1345" /> Payment_Receipt.pdf
                  </span>
                </div>
              </div>

              <div className="bg-gray-50 p-4 border border-gray-200 rounded-sm" data-id="element-1346">
                <div className="flex justify-between mb-2" data-id="element-1347">
                  <span className="font-bold text-sm text-gray-900" data-id="element-1348">
                    Seller (Respondent)
                  </span>
                  <span className="text-xs text-gray-500" data-id="element-1349">1 day ago</span>
                </div>
                <p className="text-sm text-gray-800" data-id="element-1350">
                  The refund is processed from my end. It takes 3-5 working
                  days. Here is the bank reference number.
                </p>
              </div>
            </div>

            <div className="border-t border-gray-200 pt-4" data-id="element-1351">
              <label className="text-xs font-bold text-gray-500 uppercase mb-2 block" data-id="element-1352">
                Admin Note (Internal)
              </label>
              <textarea className="w-full p-3 border border-gray-300 text-sm h-24 mb-2" placeholder="Add internal notes..." data-id="element-1353"></textarea>
              <button className="px-4 py-2 bg-gray-200 text-gray-800 text-sm font-bold hover:bg-gray-300" data-id="element-1354">
                Add Note
              </button>
            </div>
          </div>
        </div>

        <div className="space-y-6" data-id="element-1355">
          {/* Parties */}
          <div className="bg-white border border-gray-300 p-6" data-id="element-1356">
            <h3 className="font-bold text-sm uppercase text-gray-500 mb-4" data-id="element-1357">
              Involved Parties
            </h3>
            <div className="space-y-4" data-id="element-1358">
              <div data-id="element-1359">
                <p className="text-xs text-gray-400 mb-1" data-id="element-1360">Complainant</p>
                <div className="font-bold text-sm" data-id="element-1361">John Doe</div>
                <Link to="/admin/users/1" className="text-xs text-blue-600 hover:underline" data-id="element-1362">
                  View Profile
                </Link>
              </div>
              <div className="pt-4 border-t border-gray-100" data-id="element-1363">
                <p className="text-xs text-gray-400 mb-1" data-id="element-1364">Respondent</p>
                <div className="font-bold text-sm" data-id="element-1365">Amit Shah</div>
                <Link to="/admin/users/2" className="text-xs text-blue-600 hover:underline" data-id="element-1366">
                  View Profile
                </Link>
              </div>
            </div>
          </div>

          {/* Listing Info */}
          <div className="bg-white border border-gray-300 p-6" data-id="element-1367">
            <h3 className="font-bold text-sm uppercase text-gray-500 mb-4" data-id="element-1368">
              Related Listing
            </h3>
            <div className="font-bold text-sm" data-id="element-1369">Premium Corner Plot</div>
            <div className="text-xs text-gray-500 mb-2" data-id="element-1370">Hinjewadi Phase 1</div>
            <Link to="/listing/1" className="text-xs font-bold text-[#1f2933] hover:underline" data-id="element-1371">
              View Listing Page
            </Link>
          </div>
        </div>
      </div>
    </DashboardLayout>;
}